export default {
  deleteNotification (state, notification) {
    state.ui.notifications = state.ui.notifications.filter(value => value.datetime !== notification)
  },
  addNotification (state, notification) {
    state.ui.notifications = [...state.ui.notifications, notification]
  }
}
